import styled from 'styled-components';
import { Modal } from 'antd';

export const MessagesAttachmentsContainer = styled.div`
  display: inline;
  .ant-btn {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const MessagesAttachmentsModal = styled(Modal)`
  .ant-modal-body {
    padding: 16px 32px;
    overflow: auto;
    max-height: 800px;
    height: 100%;
  }

  .ant-list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.primary};
  }
`;
